export class CustomerHelper {
  static fromPayApply({ addressInfo, current: { governmentId } = {} } = {}) {
    return new CustomerHelper(addressInfo, governmentId)
  }

  constructor(addressInfo, governmentId) {
    this.addressInfo =
      addressInfo || (governmentId && { governmentId, anonymous: true }) || {}
  }

  get addresses() {
    return this.addressInfo.addresses || []
  }

  get address() {
    return (
      this.addresses.filter(({ type }) => type === 'POPULATION')[0] ||
      this.addresses[0]
    )
  }

  get governmentId() {
    return this.addressInfo.governmentId
  }

  get email() {
    return this.addressInfo.email
  }

  get aPhoneNumber() {
    return (this.phoneNumbers[0] || {}).value
  }

  get phoneNumbers() {
    const phoneNumbers = this.addressInfo.phoneNumbers
    if (phoneNumbers && phoneNumbers.length) {
      return phoneNumbers
    }
    return [
      this.addressInfo.mobilePhone,
      this.addressInfo.mobile,
      this.addressInfo.phone,
      this.addressInfo.homePhone,
    ]
      .filter(exist => exist)
      .map(value => ({ value }))
  }

  get mobilePhoneNumber() {
    return (
      this.addressInfo.mobilePhoneNumber ||
      this.phoneNumbers.filter(({ type }) => type === 'MOBILE')[0] ||
      {}
    ).value
  }

  get homePhoneNumber() {
    return (
      this.phoneNumbers.filter(({ type }) => type === 'FIXED_LINE')[0] ||
      this.phoneNumbers.filter(
        ({ type }) => type === 'FIXED_LINE_OR_MOBILE',
      )[0] ||
      {}
    ).value
  }

  get isAnonymous() {
    return this.addressInfo.anonymous || false
  }
}
